import { combineReducers } from 'redux'
import nodes from './nodes'
import edges from './edges'
import kinds from './kinds'
import selected from './selected'
import pinned from './pinned'
import focus from './focus'
import drag from './drag'
import edit from './edit'
import creating from './creating'
import culling from './culling'
import objectDetails from './objectDetails'
import previousNeighborhoods from './previousNeighborhoods'
import shapes from './shapes'


const graphReducer = combineReducers({
  nodes,
  edges,
  kinds,
  shapes,
  selected,
  pinned,
  focus,
  drag,
  edit,
  culling,
  creating,
  objectDetails,
  previousNeighborhoods
})

export default (state: unknown, action: unknown) => graphReducer(state as never, action as never)
